import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { mobileAndAbove } from '@sorare/core/src/style/mediaQuery';

import { ExperienceRewardCard_DeliverableItem } from './__generated__/index.graphql';
import experienceFront from './experience_front.png';

const CardWrapper = styled.div`
  position: relative;
`;

const Metas = styled(Vertical).attrs({ center: true, gap: 1 })`
  position: absolute;
  width: 100%;
  bottom: 12px;
  left: 0;

  @media ${mobileAndAbove} {
    bottom: var(--quadruple-unit);
  }
`;

const CardFront = styled.img`
  width: 100%;
  aspect-ratio: 0.625;
`;

const ExperienceRewardCard = ({
  experience,
}: {
  experience: ExperienceRewardCard_DeliverableItem;
}) => {
  return (
    <CardWrapper>
      <CardFront src={experienceFront} />
      <Metas>
        <div>{experience.name}</div>
      </Metas>
    </CardWrapper>
  );
};

ExperienceRewardCard.fragments = {
  deliverableItem: gql`
    fragment ExperienceRewardCard_DeliverableItem on ExperienceDeliverableItem {
      slug
      id
      name
    }
  ` as TypedDocumentNode<ExperienceRewardCard_DeliverableItem>,
};

export default ExperienceRewardCard;
